import script from "./OfMergeSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./OfMergeSearch.vue?vue&type=script&setup=true&lang=js"

import "./OfMergeSearch.vue?vue&type=style&index=0&id=5292f1ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5292f1ca"]])

export default __exports__